/**
 * Auth User Reducers
 */
import {
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILURE,
    LOGOUT_USER,
    SIGNUP_USER,
    SIGNUP_USER_SUCCESS,
    SIGNUP_USER_FAILURE,
    FETCH_PARENT_DETAILS,
    SIGNUP_USER_REGISTER,
    SIGNUP_PASSWORD_SET,
    FORGOT_PASSWORD_SEND,
    TEAM_ACCEPT_TRAVEL,
    PARENT_ACCEPT_TRAVEL,
} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    user: localStorage.getItem('user_id'),
    parentdetails:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case LOGIN_USER:
            return { ...state, loading: true };

        case LOGIN_USER_SUCCESS:
            return { ...state, loading: false, user: action.payload };

        case LOGIN_USER_FAILURE:
            return { ...state, loading: false };

        case LOGOUT_USER:
            return { ...state, user: null };

        case SIGNUP_USER:
            return { ...state, loading: true };

        case SIGNUP_USER_SUCCESS:
            return { ...state, loading: false, user: action.payload };

        case FETCH_PARENT_DETAILS:
            return { ...state, loading: false, parentdetails: action.payload };

        case SIGNUP_USER_FAILURE:
            return { ...state, loading: false };

        case SIGNUP_USER_REGISTER:
            return { ...state, loading: false };

        case SIGNUP_PASSWORD_SET:
            return { ...state, loading: false };

        case FORGOT_PASSWORD_SEND:
            return { ...state, loading: false };

        case TEAM_ACCEPT_TRAVEL:
            return { ...state, loading: false };

        case PARENT_ACCEPT_TRAVEL:
            return { ...state, loading: false };

        default: return { ...state };
    }
}
